import { DOCUMENT, inject, Injectable } from '@angular/core'

export type JsonLdProp = string | number | boolean

export interface JsonLd {
  [param: string]: JsonLdProp | JsonLdProp[] | JsonLd | JsonLd[]
}

export interface ListItemLd extends JsonLd {
  item: JsonLd
}

@Injectable({ providedIn: 'root' })
export class JsonLdService {
  private readonly doc = inject(DOCUMENT)
  private jsonLd: JsonLd[] = []

  setData(data: JsonLd | JsonLd[]) {
    this.jsonLd = []
    this.appendData(data)
  }

  appendData(data: JsonLd | JsonLd[]) {
    if (Array.isArray(data)) {
      this.jsonLd.push(...data)
    } else {
      this.jsonLd.push(data)
    }
    this.setToHead(this.jsonLd)
  }
  removeData(data: JsonLd | JsonLd[]) {
    const dataArray = Array.isArray(data) ? data : [data]
    this.jsonLd = this.jsonLd.filter((item) => !dataArray.includes(item))
    this.setToHead(this.jsonLd)
  }

  private setToHead(jsonld: readonly JsonLd[]) {
    const serialized = JSON.stringify(jsonld)
    let ldJsonScriptTag = this.doc.head.querySelector(`script[type='application/ld+json']`)
    if (ldJsonScriptTag) {
      ldJsonScriptTag.textContent = serialized
    } else {
      ldJsonScriptTag = this.doc.createElement('script')
      ldJsonScriptTag.setAttribute('type', 'application/ld+json')
      ldJsonScriptTag.textContent = serialized
      this.doc.head.appendChild(ldJsonScriptTag)
    }
  }
}
